$(document).ready(function () {

	$('.mobile-wrap').on('click', function () {
		$('.line-burger').toggleClass('line-active');
		$('.header__list').slideToggle();
	});

	$(window).resize(function () {
		if ($(window).width() > 1350) {
			$('.header__list').attr('style', '');
			$('.line-burger').removeClass('line-active');
		}
	});

});

$(document).on('click', '.header__link, .footer__link, .btn--work, .btn--contacts, .btn--header, .details__image', function () {
	let target = $(this).attr('href');
	let pos = target.indexOf('#');
	if (pos !== -1) {
		target = target.substring(pos);
		let coordsScroll = $(target).offset().top;
		$('html, body').animate({
			scrollTop: coordsScroll
		}, 800);
		if ($(window).width() < 768 && $(this).hasClass('header__link')) {
			$('.header__list').slideUp();
			$('.line-burger').removeClass('line-active');
		}
		return false;
	}
});

$(document).on('click', '#btn--regular', function () {
	$('.overlay').addClass('active');
	$('body').addClass('body-overflow');
});

$(document).on('click', '.overlay__btn', function () {
	closeOverlay();
});

$(document).on('keydown', function (e) {
	if (e.key === 'Escape' && $('.overlay').hasClass('active')) {
		closeOverlay();
	}
});

$(document).on('click', '.overlay', function (e) {
	if ($(this).hasClass('active') && !$(e.target).closest('.overlay__inner').length) {
		closeOverlay();
	}
});

function closeOverlay() {
	$('.overlay').removeClass('active');
	$('body').removeClass('body-overflow');
}

document.addEventListener('DOMContentLoaded', function () {
	const marquees = document.querySelectorAll('.reviews__marquee');

	if(marquees.length > 0) {
		[...marquees].forEach((item, index) => {
			const wrapper = item.querySelector('.swiper-wrapper');
			const totalWidth = wrapper.scrollWidth;
			const pxPerSecond = 500;
			const duration = totalWidth / pxPerSecond * 1000;

			new Swiper(item, {
				slidesPerView: 'auto',
				spaceBetween: 40,
				loop: true,
				speed: duration,
				autoplay: {
					delay: 0,
					disableOnInteraction: false,
					reverseDirection: index % 2 === 1,
				},
				allowTouchMove: false
			});
		});
	}

	function validate(input, length, regExp, error, phone) {

		$(input).on('blur keyup', function () {
			var value = $(this).val();
			var that = $(this);

			regExp = regExp == '' ? /./ : regExp;

			if (phone === true) {
				bool_reg = !regExp.test(value);
			} else {
				bool_reg = regExp.test(value);
			}

			if (value.length > length && value !== '' && bool_reg) {
				that.removeClass('form-fail').addClass('form-done');
				$(error).removeClass('active');
			} else {
				that.removeClass('form-done').addClass('form-fail');
				$(error).addClass('active');
			}
		});
	}

	// деакцивация кнопки если есть поле с ошибкой

	function disBtn(input, btn, bool) {
		var input = $(input);
		input.on('blur keyup', function () {

			if (input.hasClass('form-fail') || bool == true) {
				$(btn).attr('disabled', 'disabled');
			} else {
				$(btn).removeAttr('disabled');
			}

		});
	}

	// для проверки при нажатии

	function valClick(input, length, regExp, error, phone) {
		var value = $(input).val();

		regExp = regExp == '' ? /./ : regExp;

		if (phone === true) {
			bool_reg = regExp.test(value);
		} else {
			bool_reg = !regExp.test(value);
		}

		if (value.length < length || value === '' || bool_reg) {
			$(input).addClass('form-fail');
			$(error).addClass('active');
		}
	}

	//  деакцивация кнопки при нажатии

	function disBtnClick(input, btn) {
		var input = $(input);

		if (input.hasClass('form-fail')) {
			$(btn).attr('disabled', 'disabled');
			return false;
		} else {
			return true;
		}
	}

	//$('input[type="tel"]').mask("+38 (999) 999-99-99");

	var regName = /^[a-zA-Zа-яА-ЯёЁєЄIiЇї'`]+/;
	var regEmail = /[-.\w]+@[-.\w]+\.[-.\w]+/i;
	var regPhone = /[_]/i;

	$('#c_btn').on('click', function () {
		sendForm();
		return false;
	});

	function sendForm() {
		var name = $('#c_name').val();
		var email = $('#c_email').val();
		var msg = $('#c_msg').val();

		validate('#c_name', 1, regName, '.contacts__error--name');
		validate('#c_email', 1, regEmail, '.contacts__error--email');
		disBtn('#c_name, #c_email', '#c_btn');

		valClick('#c_name', 1, regName, '.contacts__error--name');
		valClick('#c_email', 1, regEmail, '.contacts__error--email');
		var btn_bool = disBtnClick('#c_name, #c_email', '#c_btn');

		if (btn_bool) {
			$.ajax({
				url: themeVar.url,
				type: 'POST',
				data: {
					action: 'contact',
					name: name,
					email: email,
					msg: msg,
				},
			}).done(function (data) {
				$('#c_name, #c_email, #c_msg').val('').removeClass('form-done');
				var text = 'Ваше повідомлення відправлене!';

				$('.msg-modal').html(text).addClass('msg-modal-active');
				setTimeout(function () {
					$('.msg-modal').removeClass('msg-modal-active');
				}, 2500);
			});
		}
	}

});